/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import i18next from '../../services/i18n';

const isNumber = value => Number.isFinite(value);

const triggerError = (key, value, errors) => {
  errors.threshold = {
    ...errors.threshold,
    [key]: value,
  };
};

export default (values, errors, ignoreLow) => {
  if (!isNumber(values.threshold.threshold_highest))
    triggerError('threshold_highest', i18next.t('validation.required'), errors);

  if (!isNumber(values.threshold.threshold_high))
    triggerError('threshold_high', i18next.t('validation.required'), errors);

  if (!ignoreLow && !isNumber(values.threshold.threshold_lowest))
    triggerError('threshold_lowest', i18next.t('validation.required'), errors);

  if (!ignoreLow && !isNumber(values.threshold.threshold_low))
    triggerError('threshold_low', i18next.t('validation.required'), errors);

  if (
    isNumber(values.threshold.threshold_highest) &&
    isNumber(values.limit_value) &&
    values.threshold.threshold_highest > values.limit_value
  )
    triggerError(
      'threshold_highest',
      i18next.t(
        'management_menu.asset_wizard.sensor_type.thresholds.higher_than_limit',
      ),
      errors,
    );

  if (
    isNumber(values.threshold.threshold_highest) &&
    isNumber(values.threshold.threshold_high) &&
    values.threshold.threshold_high > values.threshold.threshold_highest
  )
    triggerError(
      'threshold_high',
      i18next.t(
        'management_menu.asset_wizard.sensor_type.thresholds.higher_than_highest',
      ),
      errors,
    );

  if (
    !ignoreLow &&
    isNumber(values.threshold.threshold_high) &&
    isNumber(values.threshold.threshold_low) &&
    values.threshold.threshold_low > values.threshold.threshold_high
  )
    triggerError(
      'threshold_low',
      i18next.t(
        'management_menu.asset_wizard.sensor_type.thresholds.higher_than_high',
      ),
      errors,
    );

  if (
    !ignoreLow &&
    isNumber(values.threshold.threshold_lowest) &&
    isNumber(values.threshold.threshold_low) &&
    values.threshold.threshold_lowest > values.threshold.threshold_low
  )
    triggerError(
      'threshold_lowest',
      i18next.t(
        'management_menu.asset_wizard.sensor_type.thresholds.higher_than_low',
      ),
      errors,
    );

  if (!values.threshold.message_highest)
    triggerError('message_highest', i18next.t('validation.required'), errors);
  if (!values.threshold.message_high)
    triggerError('message_high', i18next.t('validation.required'), errors);
  if (!ignoreLow && !values.threshold.message_low)
    triggerError('message_low', i18next.t('validation.required'), errors);
  if (!ignoreLow && !values.threshold.message_lowest)
    triggerError('message_lowest', i18next.t('validation.required'), errors);
};
